





























import Enumerable from "linq";
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { ElTree } from "element-ui/types/tree";
import {
  FixedPhraseRootReference,
  FixedPhraseReference,
  IFixedPhraseReferenceTreeNode,
  IFixedPhraseReferenceTreeData
} from "../../../../domain/document";
import { DirectoryTreeNodesFactory } from "../../../system/utilities/DirectoryTreeNodesFactory";
import { TreeNodeDropType, ITreeData } from "../../../../domain/system";
import { Directory } from "../../../../domain/drawing";
import { FixedPhraseTranslator } from "./FixedPhraseTranslator";

@Component({
})
export default class FixedPhraseEditTreeSelector extends Mixins() {
  mounted(): void {
    this.loadNodes();
  }

  @Prop()
  isDialogVisible: boolean;

  @Prop()
  rootFixedPhrase: FixedPhraseRootReference;

  @Prop({ default: () => [] as number[] })
  defaultExpandedKeys: number[];

  @Prop({ default: null })
  currentNodeKey: number;

  @Prop()
  editFolderText: string;

  @Prop()
  editFixedPhraseText: string;

  @Prop()
  editFixedPhraseTitle: string;

  data(): any {
    return {
      editingRootFixedPhrase: null as FixedPhraseRootReference,
      factory: null as DirectoryTreeNodesFactory<number, FixedPhraseReference>,
      nodes: null as IFixedPhraseReferenceTreeData[],
      selectedDirectory: null as Directory<number, FixedPhraseReference>,
      selectedFixedPhrase: null as FixedPhraseReference,
      selectedNode: null as IFixedPhraseReferenceTreeNode,
      isLoading: false,
    };
  }
  editingRootFixedPhrase: FixedPhraseRootReference;
  factory: DirectoryTreeNodesFactory<number, FixedPhraseReference>;
  nodes: IFixedPhraseReferenceTreeData[];
  selectedDirectory: Directory<number, FixedPhraseReference>;
  selectedFixedPhrase: FixedPhraseReference;
  selectedNode: IFixedPhraseReferenceTreeNode;
  isLoading: boolean;

  get description(): string {
    return this.hasMultipleFolders(this.nodes) || this.hasMultipleFixedPhrases(this.nodes)
      ? "ドラッグアンドドロップで移動できます。"
      : "";
  }

  hasMultipleFolders(treeData: ITreeData<number, FixedPhraseReference>[]): boolean {
    return treeData
      && (treeData.length > 1 
        || Enumerable.from(treeData).selectMany(d => d.children).any(c => c.source && c.source instanceof Directory));
  }

  hasMultipleFixedPhrases(treeData: ITreeData<number, FixedPhraseReference>[]): boolean {
    const fixedPhrases = this.getFixedPhrases(treeData);
    return fixedPhrases && fixedPhrases.length > 1;
  }

  getFixedPhrases(references: ITreeData<number, FixedPhraseReference>[]): string[] {
    return Enumerable.from(references)
      .selectMany(r => {
        return r.source instanceof FixedPhraseReference
          ? [r.source.text]
          : this.getFixedPhrases(r.children);
      })
      .toArray();
  }

  private getTreeComponent(): ElTree<number, IFixedPhraseReferenceTreeData> {
    return this.$refs.tree as ElTree<number, IFixedPhraseReferenceTreeData>;
  }

  loadNodes(): void {
    try {
      this.isLoading = true;
      this.editingRootFixedPhrase = this.rootFixedPhrase ? this.rootFixedPhrase.clone() : null;
      this.factory = new DirectoryTreeNodesFactory(this.toFixedPhraseNode);
      this.nodes = this.factory.create(this.editingRootFixedPhrase
        ? this.editingRootFixedPhrase.folders
        : null);
      this.deselectNode();
      if (this.currentNodeKey) {
        this.$nextTick(() => {
          const tree = this.getTreeComponent();
          tree.setCurrentKey(this.currentNodeKey); // 属性のcurrent-node-keyで設定したかったが、数値直接指定では動作したが変数を入れるとなぜか動かない。
          const node = tree.getNode(this.currentNodeKey);
          this.handleNodeClicked(node.data, node, null);
          const element = tree.$el.querySelector("[data-node-key=\"" + this.currentNodeKey + "\"]");
          if (element) {
            element.scrollIntoView();
          }
        });
      }
    } finally {
      this.isLoading = false;
    }
  }

  private clearNodes(): void {
    this.nodes = [];
    this.deselectNode();
  }

  addFolder(lable: string, isAppend: boolean): void {
    // 共通のpublishIdを使用するためfactory経由でデータを作成
    const dir = [
      new Directory<number, FixedPhraseReference>(0, lable, [], []
    )];
    const nodes = this.factory.create(dir);
    this.addNode(nodes[0], isAppend);
  }

  addFixedPhrase(name: string, text: string): void {
    // 共通のpublishIdを使用するためfactory経由でデータを作成
    const dir = [
      new Directory<number, FixedPhraseReference>(0, "tmp", [], [
        new FixedPhraseReference(name, text)
      ]
    )];
    const nodes = this.factory.create(dir);
    this.addNode(nodes[0].children[0]);
  }

  private addNode(childData: IFixedPhraseReferenceTreeData, isAppend: boolean = true): void {
    const tree = this.getTreeComponent();
    if (this.selectedNode === null) {
      const node = tree as any; // rootが必要なのでanyに変換
      tree.append(childData, node.root);
    } else if (this.selectedNode.data.source instanceof Directory) {
      if (isAppend) {
        tree.append(childData, this.selectedNode.data);
        this.sortNode(this.selectedNode);
        this.selectedNode.expanded = true;  // 子を追加したので開く
      } else {
        tree.insertAfter(childData, this.selectedNode.data);
        this.sortNode(this.selectedNode.parent);
      }
    } else if (this.selectedNode.data.source instanceof FixedPhraseReference) {
      tree.append(childData, this.selectedNode.parent.data);
      this.sortNode(this.selectedNode.parent);
    }
  }

  deleteFolder(): void {
    this.deleteNode();
  }

  deleteFixedPhrase(): void {
    this.deleteNode();
  }

  private deleteNode(): void {
    if (this.selectedNode === null) {
      return;
    }
    const tree = this.getTreeComponent();
    tree.remove(this.selectedNode.data);
    this.selectedNode = null;
  }

  createFixedPhrase(): FixedPhraseRootReference {
    const translator = new FixedPhraseTranslator();
    const tree = this.getTreeComponent();
    return translator.toFixedPhraseTree(this.editingRootFixedPhrase.tableId, this.editingRootFixedPhrase.templateId, tree.data);
  }

  @Watch("isDialogVisible")
  onDialogVisibleUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue) {
      this.loadNodes();
    } else {
      this.clearNodes();
    }
  }

  @Watch("editFolderText")
  onEditFolderTextUpdated(newValue: string, oldValue: string): void {
    // フォルダ名称を空にしたときに反映しない挙動になっている
    // いまいちな挙動ではあるが、名称が空の時にツリーアイコンが表示されなくて操作に支障があるのと、現状で現実的に問題は無いため、とりあえずはスルーしている
    if (this.selectedNode === null || newValue === "") {
      return;
    }
    const data = this.selectedNode.data;
    if (data.source instanceof Directory) {
      data.source.name = newValue;
      data.label = newValue;
    }
  }

  @Watch("editFixedPhraseText")
  onEditFixedPhraseTextUpdated(newValue: string, oldValue: string): void {
    if (this.selectedNode === null) {
      return;
    }
    // 定型文のテキストが空の場合は登録させないよう登録前にチェックがある
    const data = this.selectedNode.data;
    if (data.source instanceof FixedPhraseReference) {
      data.source.text = newValue;
      data.label = this.getPhraseReferenceNodeLabel(data.source);
    }
  }

  @Watch("editFixedPhraseTitle")
  onEditFixedPhraseTitleUpdated(newValue: string): void {
    if (this.selectedNode === null) {
      return;
    }
    const data = this.selectedNode.data;
    if (data.source instanceof FixedPhraseReference) {
      data.source.name = newValue;
      data.label = this.getPhraseReferenceNodeLabel(data.source);
    }
  }

  private getPhraseReferenceNodeLabel(source: FixedPhraseReference): string {
    const emptyLabel = "(名称無し)";
    if (!source) { return emptyLabel; }
    return source.name
      ? source.name
      : (source.text ? source.text : emptyLabel);
  }

  @Watch("selectedDirectory")
  onSelectedDirectoryUpdated(newValue: Directory<number, FixedPhraseReference>, oldValue: Directory<number, FixedPhraseReference>): void {
    this.inputDirectory(newValue);
  }

  @Watch("selectedFixedPhrase")
  onSelectedFixedPhraseUpdated(newValue: FixedPhraseReference, oldValue: FixedPhraseReference): void {
    this.inputFixedPhrase(newValue);
  }

  @Emit("inputDirectory")
  inputDirectory(value: Directory<number, FixedPhraseReference>): void {}

  @Emit("inputFixedPhrase")
  inputFixedPhrase(value: FixedPhraseReference): void {}

  toFixedPhraseNode(entity: FixedPhraseReference, i: number): IFixedPhraseReferenceTreeData {
    return {
      id: i,
      label: this.getPhraseReferenceNodeLabel(entity),
      iconClass: "tree-icon-fixed-phrase",
      source: entity,
      children: [],
    };
  }

  nodeClass(node: IFixedPhraseReferenceTreeNode): string {
    if (node.data instanceof Object) {
      if (node.data.source instanceof Directory) {
        return node.expanded
          ? "tree-icon-directory-expand"
          : "tree-icon-directory";
      }
      return "tree-icon-fixed-phrase";
    }
    return "";
  }

  nodeLabel(node: IFixedPhraseReferenceTreeNode): string {
    return node.label;
  }

  handleNodeClicked(nodeObject: IFixedPhraseReferenceTreeData, nodeProperty: IFixedPhraseReferenceTreeNode, nodeSelf: any): void {
    if (this.selectedNode && this.selectedNode.key === nodeProperty.key) {
      this.deselectNode();
      return;
    }
    const source = nodeObject.source;
    if (source instanceof Directory) {
      this.selectedDirectory = source;
      this.selectedFixedPhrase = null;
    }
    if (source instanceof FixedPhraseReference) {
      this.selectedDirectory = null;
      this.selectedFixedPhrase = source;
    }
    if (nodeProperty.childNodes instanceof Array && nodeProperty.childNodes.length === 0) {
      nodeProperty.expanded = false;  // 移動等でファイルが無くなっていた場合はとりあえず閉じる
    }
    this.selectedNode = nodeProperty;
  }

  private deselectNode() {
    this.getTreeComponent().setCurrentKey(null);
    this.selectedDirectory = null;
    this.selectedFixedPhrase = null;
    this.selectedNode = null;
  }

  allowDrop(draggingNode: IFixedPhraseReferenceTreeNode, dropNode: IFixedPhraseReferenceTreeNode, type: TreeNodeDropType): boolean {
    const dropNodeSource = dropNode.data.source;
    if (dropNodeSource instanceof FixedPhraseReference && type === "inner") {
      return false; // 定型文の内側は全て禁止
    }
    const draggingNodeSource = draggingNode.data.source;
    if (draggingNodeSource instanceof FixedPhraseReference && dropNodeSource instanceof Directory && type !== "inner") {
      return false; // 定型文はフォルダの内側以外禁止
    }
    return true;
  }

  allowDrag(draggingNode: IFixedPhraseReferenceTreeNode): boolean {
    return true;
  }

  nodeDrop(draggingNode: IFixedPhraseReferenceTreeNode, dropNode: IFixedPhraseReferenceTreeNode, type: TreeNodeDropType): void {
    this.sortNode(type === "inner"
      ? dropNode          // ドロップ先をソート
      : dropNode.parent); // ドロップした兄弟をソートするため親を渡す
    dropNode.expanded = true; // 追加したので開く
  }

  sortNode(node: IFixedPhraseReferenceTreeNode): void {
    if (node.childNodes instanceof Array) {
      node.childNodes.sort((a: IFixedPhraseReferenceTreeNode, b: IFixedPhraseReferenceTreeNode) => {
        const sourceA = a.data.source instanceof Directory ? 0 : 1;
        const sourceB = b.data.source instanceof Directory ? 0 : 1;
        return sourceA - sourceB;
      });
    }
    if (node.data !== null && node.data.children instanceof Array) {
      node.data.children.sort((a: IFixedPhraseReferenceTreeData, b: IFixedPhraseReferenceTreeData) => {
        const sourceA = a.source instanceof Directory ? 0 : 1;
        const sourceB = b.source instanceof Directory ? 0 : 1;
        return sourceA - sourceB;
      });
    }
  }

  hasEdited(): boolean {
    const old = JSON.stringify(this.rootFixedPhrase);
    const now = JSON.stringify(this.createFixedPhrase());
    return old !== now;
  }

  import(treeData: IFixedPhraseReferenceTreeData[]): void {
    try {
      if (!treeData || treeData.length === 0) { return; }
      const addedFolderIds: { originalId: number, id: number }[] = [];

      treeData.forEach(data => {
        if (data.parent) {
          const isParentAdded = addedFolderIds.some(f => f.originalId === data.parent.id);
          const parentId = isParentAdded
            ? addedFolderIds.find(f => f.originalId === data.parent.id).id
            : this.importDirectory(data.parent.label);
          
          if (!isParentAdded) {
            addedFolderIds.push({ originalId: data.parent.id, id: parentId });
          }
          if (data.source instanceof Directory) {
            const directoryId = this.importDirectory(data.label, parentId);
            addedFolderIds.push({ originalId: data.id, id: directoryId });
          } else if (data.source instanceof FixedPhraseReference) {
            this.importFixedPhrase(data, parentId);
          }
        } else {
          if (data.source instanceof Directory) {
            const directoryId = this.importDirectory(data.label);
            addedFolderIds.push({ originalId: data.id, id: directoryId });
          }
        }
      });
    } catch (e) {
      this.$error(
        "インポート失敗",
        "定型文のインポートに失敗しました。",
        e,
      );
    }
  }

  private importDirectory(label: string, parentId?: number): number {
    const directories = [
      new Directory<number, FixedPhraseReference>(0, label, [], []
    )];
    const nodes = this.factory.create(directories);
    const childData = nodes[0];
    const tree = this.getTreeComponent();
    if (this.selectedNode === null) {
      const node = tree as any; // rootが必要なのでanyに変換
      tree.append(childData, (parentId ? parentId : node.root));
    } else if (this.selectedNode.data.source instanceof Directory) {
      tree.append(childData, (parentId ? parentId : this.selectedNode.data));
      this.sortNode(this.selectedNode);
      this.selectedNode.expanded = true;
    } else if (this.selectedNode.data.source instanceof FixedPhraseReference) {
      tree.append(childData, (parentId ? parentId : this.selectedNode.parent.data));
      this.sortNode(this.selectedNode.parent);
    }
    return childData.id;
  }

  private importFixedPhrase(data: IFixedPhraseReferenceTreeData, parentId: number): void {
    const source = data.source as FixedPhraseReference;
    const directories = [
      new Directory<number, FixedPhraseReference>(0, "tmp", [], [
        new FixedPhraseReference(
          source ? source.name : "",
          source ? source.text : data.label
        )
      ]
    )];
    const nodes = this.factory.create(directories);
    const childData = nodes[0].children[0];
    const tree = this.getTreeComponent();
    tree.append(childData, parentId);
    if (this.selectedNode && this.selectedNode.data.source instanceof Directory) {
      this.sortNode(this.selectedNode);
      this.selectedNode.expanded = true;
    } else if (this.selectedNode && this.selectedNode.data.source instanceof FixedPhraseReference) {
      this.sortNode(this.selectedNode.parent);
    }
  }
}
